module.exports = __webpack_public_path__ + "static/media/zoom.5a2b37fd.png";